export default __webpack_public_path__ + "static/media/sideMenuCheck.1733f0b1.svg";